import { forwardRef } from 'react';
import Enhancer from './enhancer';
import InputInternal from './input-internal';
const Input = forwardRef(InputInternal);
const InputNamespace = Object.assign(Input, {
    Enhancer,
});
export default InputNamespace;
